export var MOBILE_MAX_WIDTH = 559;
export var NARROW_MAX_WIDTH = 729;
export var DESKTOP_MIN_HEIGHT = 480;
export var MOBILE_STICKY_MIN_HEIGHT = 400;
//# sourceMappingURL=index.js.map